import React, { useCallback, useEffect, useState } from "react";
import {
  Box,
  IconButton,
  SelectChangeEvent,
  Tooltip,
  Typography,
} from "@mui/material";
import { Grid } from "@material-ui/core";
import CustomModal from "../../components/common/customModal";
import CustomInput from "../../components/common/inputField";
import CustomSelect from "../../components/common/customSelect";
import {
  CrossFunctionalAwardTypeEnum,
  CategoryType,
  AwardTypeEnum,
  CrossFunctionalTypeEnum,
} from "../../helper/typeEnum";
import {
  BudgetData,
  RewardsPointScoreData,
  RewardsRecognitionDataData,
  RewardsRecognitionFormData,
  RewardsRecognitionFormError,
} from "../../types/dashboard";
import AutoCompleteMultiSelect from "../../components/autoCompleteInput";
import dashboardService from "../../services/DashboardServices";
import { showToast } from "../../components/common/toastNotification";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import {
  //CrossFunctionalScoreTable,
  //CrossFunctionalScoreTableTrailBlazer,
  REExcellenceScoreTable,
  TrailBlazerScoreTable,
} from "../../components/R&R/RRScoreTable";
import { LoginRootState } from "../../types/login";
import { useAppSelector } from "../../globalState/hooks";

interface RewardsAndRecognitionModalProps {
  open: boolean;
  onClose: () => void;
  onSave: () => void;
  rewardsRecognitionData?: RewardsRecognitionDataData[];
}

const RewardsAndRecognitionModal: React.FC<RewardsAndRecognitionModalProps> = ({
  open,
  onClose,
  onSave,
  rewardsRecognitionData,
}) => {
  const [rewardTypeData, setRewardTypeData] = useState<
    { label: string; value: number | string }[]
  >([]);
  const [selectedRewardType, setSelectedRewardType] = useState(0);
  const [typeData, setTypeData] = useState<
    { label: string; value: number | string }[]
  >([]);
  const [awardTypeData, setAwardTypeData] = useState<
    { label: string; value: number | string }[]
  >([]);
  const [pointScoreList, setPointScoreList] = useState<RewardsPointScoreData[]>(
    []
  );
  const [isPreview, setIsPreview] = useState(false);

  const [formData, setFormData] = useState<RewardsRecognitionFormData>({
    awardTypeId: 0,
    categoryTypeId: 0,
    awardType: 0,
    userIds: [],
    achievementDetails: "",
    score: "",
    points: "",
    crossFunctionalType: 0,
  });

  const [formErrors, setFormErrors] = useState({
    categoryType: "",
    awardType: "",
    userIds: "",
    achievementDetails: "",
    score: "",
    crossFunctionalType: "",
  });
  const [criteriaFormData, setCriteriaFormData] = useState<
    { rewardNominationCriteriaId: number; point: number }[]
  >([]);
  const [criteriaErrors, setCriteriaErrors] = useState<Record<number, string>>(
    {}
  );
  const [isScorePointValid, setIsScorePointValid] = useState(false);
  const [btnLoading, setBtnLoading] = useState(false);
  const [rewardsTypeError, setRewardsTypeError] = useState("");
  const [totalScore, setTotalScore] = useState(0);
  const [totalScoreError, setTotalScoreError] = useState("");
  const [crossFunctionalTypeData, setCrossFunctionalTypeData] = useState<
    { label: string; value: number | string }[]
  >([]);
  const [criteriaData, setCriteriaData] = useState<
    { id: number; name: string }[]
  >([]);

  const userDetails = useAppSelector(
    (state: LoginRootState) => state.authReducer.loginDetials
  );
  const [budgetData, setBudgetData] = useState<BudgetData | null>(null);
  const [showConfirmModal, setShowConfirmModal] = useState(false);

  const handelGetBudgetDataofCXOorHead = useCallback(async () => {
    const EmpId = userDetails?.userId;

    try {
      const response = await dashboardService.getBudgetDataofCXOorHead(EmpId);
      if (response?.data?.success && response.data.data) {
        setBudgetData(response.data.data);
      }
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error("Failed to fetch budget data:", error);
    }
  }, [userDetails?.userId]);
  useEffect(() => {
    if (userDetails?.isHeadOrCXO) {
      handelGetBudgetDataofCXOorHead();
    }
    const tempType = Object.entries(CategoryType).map(([key, value]) => ({
      label: key,
      value: value,
    }));

    setTypeData(tempType);

    const tempAwardType = Object.entries(CrossFunctionalAwardTypeEnum).map(
      ([key, value]) => ({
        label: key,
        value: value,
      })
    );

    setAwardTypeData(tempAwardType);
    const tempCrossFunctionalType = Object.entries(CrossFunctionalTypeEnum).map(
      ([key, value]) => ({
        label: key,
        value: value,
      })
    );
    setCrossFunctionalTypeData(tempCrossFunctionalType);

    const tempRRAwardType = Object.entries(AwardTypeEnum).map(
      ([key, value]) => ({
        label: key,
        value: value,
      })
    );
    if (userDetails?.isHeadOrCXO) {
      setRewardTypeData(tempRRAwardType);
    } else {
      const filteredData = tempRRAwardType.filter((item) => item.value == "4");
      setRewardTypeData(filteredData);
    }
  }, [handelGetBudgetDataofCXOorHead, userDetails?.isHeadOrCXO]);

  // Function to fetch Open Road data
  const fetchCriteriaByAwardIdDataList = async () => {
    try {
      const response = await dashboardService.getCriteriaByAwardIdAPI(2);
      if (response?.data?.data.length > 0) {
        setCriteriaData(response?.data?.data);
      } else {
        setCriteriaData([]);
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  /// Fetch to Point Score master List
  const fetchPointScoreMasterList = async (
    selectedType: number,
    selectedCrossFunctionalTypeId?: number
  ) => {
    try {
      const response = await dashboardService.getPointMasterAPI();
      if (response?.data?.data.length > 0) {
        const responseData = response.data.data;

        const finalAwardTypeData = responseData.filter(
          (item: RewardsPointScoreData) => {
            if (selectedType === 3) {
              return (
                item.awardTypeId === selectedType &&
                item.crossFunctionalTypeId === selectedCrossFunctionalTypeId
              );
            } else {
              return item.awardTypeId === selectedType;
            }
          }
        );

        setPointScoreList(finalAwardTypeData);
      } else {
        setPointScoreList([]);
      }
    } catch (error) {
      console.error("Error feching Point master", error);
    }
  };

  //// handle User Select Onchange
  const handleUsersSelection = (
    selectedUsers: { id: number; name: string }[],
    checkInput: string
  ) => {
    const checkFormTabs = formData.awardTypeId !== 4;

    if (formData.categoryTypeId === 0 && checkFormTabs) {
      showToast("First select type.", "error");
      return;
    }

    if (checkInput === "add") {
      const lastSelectedUser = selectedUsers[selectedUsers.length - 1];

      const isUserAlreadySelected = formData.userIds.some(
        (user) => user.id === lastSelectedUser.id
      );

      if (isUserAlreadySelected) {
        showToast("This employee is already selected!", "error");
        return;
      }

      if (formData.categoryTypeId === 1 && selectedUsers.length > 1) {
        showToast(
          "You can nominate only one employee under individual award",
          "error"
        );
        return;
      }

      if (selectedUsers.length > 5) {
        showToast("You can nominate a maximum of 5 employees only", "error");
        return;
      }

      // Merge old and new users, ensuring uniqueness
      const uniqueUsers = [...formData.userIds, lastSelectedUser].filter(
        (user, index, self) => self.findIndex((u) => u.id === user.id) === index
      );

      setFormData((prevData) => ({
        ...prevData,
        userIds: uniqueUsers,
      }));
      setFormErrors((prevData) => ({
        ...prevData,
        userIds: "",
      }));
    } else {
      const uniqueUsers = selectedUsers.filter(
        (user, index, self) => self.findIndex((u) => u.id === user.id) === index
      );

      if (uniqueUsers.length < selectedUsers.length) {
        showToast("This employee is already selected!", "error");
      }

      setFormData((prevData) => ({
        ...prevData,
        userIds: uniqueUsers,
      }));
      setFormErrors((prevData) => ({
        ...prevData,
        userIds: "",
      }));
    }
  };

  //// Input onchange code
  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = event.target;

    if (name === "score") {
      if (formData.awardTypeId === 3 && formData.crossFunctionalType === 0) {
        setFormErrors((prevErrors) => ({
          ...prevErrors,
          [name]: "Select Cross Functional Type First",
        }));
        return;
      }
      const trimmedValue = value.replace(/\s/g, "");

      if (!/^\d*(\.\d*)?$/.test(trimmedValue)) {
        setFormErrors((prevErrors) => ({
          ...prevErrors,
          [name]: "Only numeric values are allowed.",
        }));
        return;
      }
      if (trimmedValue.includes(".")) {
        const [, decimalPart] = trimmedValue.split(".");
        if (decimalPart.length > 2) {
          setFormErrors((prevErrors) => ({
            ...prevErrors,
            [name]: "Only up to 2 digits allowed after the decimal point.",
          }));
          return;
        }
      }
      const enteredScore = parseFloat(trimmedValue) || 0;
      let points = 0;
      let errorMessage = "";
      const selectedScoreRange = pointScoreList.find(
        (range) =>
          range.awardTypeId === formData.awardTypeId &&
          range.crossFunctionalTypeId === formData.crossFunctionalType &&
          enteredScore >= range.minScore &&
          enteredScore <= range.maxScore
      );
      if (selectedScoreRange) {
        if (formData.awardTypeId === 1) {
          points =
            formData.categoryTypeId === 1
              ? selectedScoreRange.individualPoints
              : selectedScoreRange.teamPoints;
        } else if (formData.awardTypeId === 2) {
          points =
            formData.categoryTypeId === 2
              ? selectedScoreRange.teamPoints
              : selectedScoreRange.individualPoints;
        } else if (formData.awardTypeId === 3) {
          points =
            formData.categoryTypeId === 2
              ? selectedScoreRange.teamPoints
              : selectedScoreRange.individualPoints;
        }

        setIsScorePointValid(false);

        setFormErrors((prevErrors) => ({
          ...prevErrors,
          [name]: "",
        }));
      } else {
        setIsScorePointValid(true);
        errorMessage = `Score must be between ${
          pointScoreList[0].minScore
        } and ${pointScoreList[pointScoreList.length - 1].maxScore}`;

        setFormErrors((prevErrors) => ({
          ...prevErrors,
          [name]: errorMessage,
        }));
      }

      setFormData((prev) => ({
        ...prev,
        [name]: trimmedValue,
        points: String(points),
      }));
    } else if (name === "achievementDetails") {
      const trimmedValue = value.replace(/\s+/g, " ");

      if (trimmedValue.length < 999) {
        setFormData((prev) => ({
          ...prev,
          [name]: trimmedValue,
        }));
      }

      setFormErrors((prevErrors) => ({
        ...prevErrors,
        [name]: "",
      }));
    } else {
      setFormData((prev) => ({
        ...prev,
        [name]: value,
      }));

      setFormErrors((prevErrors) => ({
        ...prevErrors,
        [name]: "",
      }));
    }
  };

  //// handle Dynamic input change
  const handleCriteriaInputOnChange = (id: number, value: string) => {
    if (!/^\d+$/.test(value) && value !== "") return;

    const numericValue = Number(value);
    if (numericValue < 0 || numericValue > 25) return;

    setCriteriaFormData((prev) => {
      const updatedFormData = prev.map((item) =>
        item.rewardNominationCriteriaId === id
          ? { ...item, point: numericValue }
          : item
      );

      if (
        !updatedFormData.some((item) => item.rewardNominationCriteriaId === id)
      ) {
        updatedFormData.push({
          rewardNominationCriteriaId: id,
          point: numericValue,
        });
      }

      const total = updatedFormData.reduce((sum, item) => sum + item.point, 0);
      setTotalScore(total);
      handleCheckScopeLimit(total.toString());

      return updatedFormData;
    });

    setCriteriaErrors((prev) => ({
      ...prev,
      [id]:
        value.trim() === ""
          ? "This field is required"
          : numericValue < 10
          ? "Minimum value should be 10"
          : "",
    }));
  };

  const handleCheckScopeLimit = (value: string) => {
    const enteredScore = parseFloat(value) || 0;
    let points = 0;
    let errorMessage = "";

    const selectedScoreRange = pointScoreList.find(
      (range) =>
        enteredScore >= range.minScore && enteredScore <= range.maxScore
    );

    if (selectedScoreRange) {
      if (formData.awardTypeId === 1) {
        points =
          formData.categoryTypeId === 1
            ? selectedScoreRange.individualPoints
            : selectedScoreRange.teamPoints;
      } else if (formData.awardTypeId === 2) {
        points =
          formData.categoryTypeId === 2
            ? selectedScoreRange.teamPoints
            : selectedScoreRange.individualPoints;
      }

      setIsScorePointValid(false);
    } else {
      setIsScorePointValid(true);
      errorMessage = `Score must be between ${pointScoreList[0].minScore} and ${
        pointScoreList[pointScoreList.length - 1].maxScore
      }`;
    }

    setFormData((prev) => ({
      ...prev,
      ["score"]: value,
      points: String(points),
    }));

    setTotalScoreError(errorMessage);
  };

  /// hande Drop down onchange code
  const handleTypeDropDownChange = (
    event: SelectChangeEvent<string | number>
  ) => {
    const { value, name } = event.target;
    if (name === "rewardType") {
      const newRewardType = Number(value);
      setSelectedRewardType(newRewardType);
      fetchCriteriaByAwardIdDataList();
      setRewardsTypeError("");

      setFormData({
        awardTypeId: newRewardType,
        categoryTypeId: 0,
        awardType: 0,
        userIds: [],
        achievementDetails: "",
        score: "",
        points: "",
        crossFunctionalType: 0,
      });

      setFormErrors({
        categoryType: "",
        awardType: "",
        userIds: "",
        achievementDetails: "",
        score: "",
        crossFunctionalType: "",
      });

      setIsScorePointValid(false);
      fetchPointScoreMasterList(newRewardType);
      return;
    }

    setFormData((prev) => ({
      ...prev,
      [name]: +value,
      ...(name === "categoryTypeId" && {
        userIds: [],
        score: "",
        points: "",
        achievementDetails: "",
      }),
    }));

    setCriteriaFormData([]);

    setCriteriaErrors({});

    setFormErrors((prevErrors) => ({
      ...prevErrors,
      categoryType: "",
      awardType: "",
      crossFunctionalType: "",
      ...(name === "categoryTypeId" && { userIds: "" }),
    }));

    if (name === "crossFunctionalType") {
      const newCrossFunctionalType = +value;
      setFormErrors((prevErrors) => ({
        ...prevErrors,
        score: "",
      }));
      setIsScorePointValid(true);
      setFormData((prev) => ({
        ...prev,
        crossFunctionalType: newCrossFunctionalType,
        score: "",
      }));
      if (newCrossFunctionalType === 0) {
        setFormErrors((prevErrors) => ({
          ...prevErrors,
          score: "",
        }));
      }

      fetchPointScoreMasterList(formData.awardTypeId, newCrossFunctionalType);
    }
  };

  /// handle Form validation code
  const validateForm = () => {
    const errors: RewardsRecognitionFormError = {};
    const newErrors: Record<number, string> = {};

    if (formData.awardTypeId !== 4) {
      if (!formData.categoryTypeId) {
        errors.categoryType = "Type is required.";
      }
    }

    if (
      formData.awardTypeId === 3 &&
      !formData.awardType &&
      formData.crossFunctionalType === 2
    ) {
      errors.awardType = "Award Type is required.";
    }

    if (!formData.userIds || formData.userIds.length === 0) {
      errors.userIds = "Nominate Employee is required.";
    }

    if (formData.awardTypeId === 3 && !formData.crossFunctionalType) {
      errors.crossFunctionalType = "Cross Functional Type is required.";
    }

    if (
      formData.categoryTypeId !== 1 &&
      formData.awardTypeId !== 4 &&
      formData.userIds.length < 2
    ) {
      errors.userIds = "Nominate minimum of 2 employees under the type 'Team'";
    }

    if (!formData.achievementDetails.trim()) {
      errors.achievementDetails = "Achievement Details is required.";
    }

    if (formData.awardTypeId !== 4 && formData.awardTypeId !== 2) {
      if (!formData.score.trim()) {
        errors.score = "Score is required.";
      } else {
        const enteredScore = parseFloat(formData.score) || 0;
        const selectedScoreRange = pointScoreList.find(
          (range) =>
            enteredScore >= range.minScore && enteredScore <= range.maxScore
        );

        if (!selectedScoreRange) {
          errors.score = `Score must be between ${
            pointScoreList[0].minScore
          } and ${pointScoreList[pointScoreList.length - 1].maxScore}`;
        }
      }
    }

    // 🎯 Validate Criteria Fields for Award Type 2
    if (formData.awardTypeId === 2) {
      criteriaData.forEach(({ id }) => {
        const criteriaEntry = criteriaFormData.find(
          (item) => item.rewardNominationCriteriaId === id
        );

        const value = criteriaEntry?.point;

        if (value === undefined || value === null || isNaN(value)) {
          newErrors[id] = "This field is required";
        } else if (value < 10 || value > 25) {
          newErrors[id] = "Score should be between 10 and 25";
        }
      });
    }

    setCriteriaErrors(newErrors);
    setFormErrors({
      categoryType: errors.categoryType || "",
      awardType: errors.awardType || "",
      userIds: errors.userIds || "",
      achievementDetails: errors.achievementDetails || "",
      score: errors.score || "",
      crossFunctionalType: errors.crossFunctionalType || "",
    });

    return (
      Object.keys(errors).length === 0 && Object.keys(newErrors).length === 0
    );
  };

  ////handle Save Data
  const handleSaveData = async () => {
    if (selectedRewardType !== 0) {
      if (!validateForm()) return;
      if (!isScorePointValid) {
        try {
          setBtnLoading(true);
          const inputData = {
            awardId: formData.awardTypeId,
            CrossFunctionalAwardTypeId: formData.awardType
              ? formData.awardType
              : null,
            crossFunctionalTypeId: formData.crossFunctionalType
              ? formData.crossFunctionalType
              : null,
            categoryId: formData.categoryTypeId,
            userIds: formData.userIds.map((user) => String(user.id)),
            achievementDetails: formData.achievementDetails,
            score: formData.score
              ? parseFloat(formData.score.toString())
              : null,

            points: formData.points ? formData.points : null,
            lstReExcellenceCriteria: criteriaFormData ? criteriaFormData : [],
          };

          await dashboardService
            .AddRewardAndRecognizationDataAPI(inputData)
            .then((response) => {
              if (response && response.data) {
                if (response.data.statusCode === 400) {
                  showToast(response.data.message, "error");
                  return;
                }
                showToast(response.data.message, "success");

                setFormData({
                  awardTypeId: 0,
                  categoryTypeId: 0,
                  awardType: 0,
                  userIds: [],
                  achievementDetails: "",
                  score: "",
                  points: "",
                  crossFunctionalType: 0,
                });
                onSave();
                onClose();
              } else {
                showToast(response?.data?.message || "Error occurred", "error");
              }
            })
            .catch((error) => {
              console.error("Error:", error);
            })
            .finally(() => {
              setBtnLoading(false);
            });
        } catch (error) {
          console.error("Error:", error);
        }
      } else {
        setFormErrors((prevErrors) => ({
          ...prevErrors,
          ["score"]: formErrors.score,
        }));
      }
    } else {
      setRewardsTypeError("Reward Type is required.");
    }
  };
  ////handle Preview function

  const handlePreview = () => {
    if (!validateForm()) return;

    if (isScorePointValid) {
      setFormErrors((prev) => ({
        ...prev,
        score: formErrors.score || "Please fix the score before preview",
      }));
      return;
    }
    // only check for last 30 days
    const now = new Date();
    const thirtyDaysAgo = new Date();
    thirtyDaysAgo.setDate(now.getDate() - 30);

    const isDuplicate = rewardsRecognitionData?.some((item) => {
      const createdAt = new Date(item.createdAt);
      return (
        item.awardId === formData.awardTypeId &&
        item.nominatedBy === userDetails?.userId &&
        createdAt >= thirtyDaysAgo &&
        createdAt <= now &&
        item.lstRewardAndRecognizationNomination_Members?.some((member) =>
          formData.userIds.some((u) => String(u.id) === String(member.userId))
        )
      );
    });

    if (isDuplicate) {
      setShowConfirmModal(true);
    } else {
      setIsPreview(true);
    }
  };

  return (
    <>
      <CustomModal
        open={open}
        handleClose={onClose}
        onSave={isPreview ? handleSaveData : handlePreview}
        title={"Rewards and Recognition"}
        width={800}
        saveButtonName={isPreview ? "Submit" : "Preview"}
        btnLoading={btnLoading}
        {...(isPreview && {
          button2: "Edit",
          onClickButton2: () => setIsPreview(false),
        })}
      >
        <Box className={`reward-modal ${isPreview ? "readonly-mode" : ""}`}>
          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <CustomSelect
                name="rewardType"
                label="Reward Type"
                placeHolder="Select Reward Type"
                value={selectedRewardType || ""}
                onChange={handleTypeDropDownChange}
                error={rewardsTypeError}
                options={rewardTypeData}
                required
                readOnly={isPreview}
              />
            </Grid>
            {selectedRewardType === 3 && (
              <Grid item xs={12} md={6}>
                <CustomSelect
                  name="crossFunctionalType"
                  label="Cross Functional Type"
                  placeHolder="Select Cross Functional Type"
                  value={formData.crossFunctionalType || ""}
                  onChange={handleTypeDropDownChange}
                  error={formErrors.crossFunctionalType}
                  required
                  options={crossFunctionalTypeData}
                  readOnly={isPreview}
                />
              </Grid>
            )}
            {selectedRewardType !== 0 && (
              <>
                {selectedRewardType === 4 ? (
                  <>
                    <Grid item xs={12} md={6}>
                      <AutoCompleteMultiSelect
                        selectedValues={formData.userIds}
                        onChange={handleUsersSelection}
                        label="Nominate Employee"
                        placeholder={isPreview ? "" : "Search Employees..."}
                        error={formErrors.userIds}
                        awardTypeId={selectedRewardType}
                        readOnly={isPreview}
                        required
                      />
                    </Grid>
                    <Grid item xs={12} md={12}>
                      <CustomInput
                        label="Achievement Details"
                        type="text"
                        name="achievementDetails"
                        placeholder="Enter Achievement Details"
                        value={formData.achievementDetails}
                        onChange={handleInputChange}
                        error={formErrors.achievementDetails}
                        required
                        rows={3}
                        maxLength={300}
                        readOnly={isPreview}
                        showCharCount
                      />
                    </Grid>
                  </>
                ) : (
                  <>
                    {/* {selectedRewardType !== 3 && ( */}
                    <Grid item xs={12} md={6}>
                      <CustomSelect
                        name="categoryTypeId"
                        label="Type"
                        placeHolder="Select Type"
                        value={formData.categoryTypeId || ""}
                        onChange={handleTypeDropDownChange}
                        error={formErrors.categoryType}
                        required
                        options={typeData}
                        readOnly={isPreview}
                      />
                    </Grid>
                    {/* )} */}

                    <Grid item xs={12} md={12}>
                      <AutoCompleteMultiSelect
                        selectedValues={formData.userIds}
                        onChange={handleUsersSelection}
                        label={
                          formData.categoryTypeId === 1
                            ? "Nominate Employee"
                            : "Nominate Employee (Min 2 and Max 5)"
                        }
                        placeholder={isPreview ? "" : "Search Employees..."}
                        error={formErrors.userIds}
                        awardTypeId={selectedRewardType}
                        required
                        readOnly={isPreview}
                      />
                    </Grid>

                    <Grid item xs={12} md={12}>
                      <CustomInput
                        label="Achievement Details"
                        type="text"
                        name="achievementDetails"
                        placeholder="Enter Achievement Details"
                        value={formData.achievementDetails}
                        onChange={handleInputChange}
                        error={formErrors.achievementDetails}
                        required
                        rows={3}
                        maxLength={300}
                        showCharCount
                        readOnly={isPreview}
                      />
                    </Grid>

                    {selectedRewardType === 2 &&
                      criteriaData.map((data) => {
                        return (
                          <Grid item xs={12} md={6} key={data.id}>
                            <CustomInput
                              label={`${data.name} (Min 10 and Max 25)`}
                              type="text"
                              name=""
                              placeholder={`Enter ${data.name}`}
                              readOnly={isPreview}
                              value={
                                criteriaFormData
                                  .find(
                                    (item) =>
                                      item.rewardNominationCriteriaId ===
                                      data.id
                                  )
                                  ?.point?.toString() || ""
                              }
                              onChange={(e) =>
                                handleCriteriaInputOnChange(
                                  data.id,
                                  e.target.value
                                )
                              }
                              error={criteriaErrors[data.id] || ""}
                              required
                            />
                          </Grid>
                        );
                      })}

                    {selectedRewardType === 2 && (
                      <>
                        <Grid item xs={12} md={6}>
                          <Typography
                            className="f-11"
                            style={{
                              color: "#CCCCCC",
                              display: "flex",
                              alignItems: "center",
                            }}
                          >
                            Total Score:
                            <Tooltip
                              title={<REExcellenceScoreTable />}
                              placement="right"
                              componentsProps={{
                                tooltip: {
                                  sx: {
                                    bgcolor: "#fff",
                                    color: "#222",
                                    boxShadow: 2,
                                    p: 1,
                                    maxWidth: 350,
                                  },
                                },
                              }}
                            >
                              <IconButton
                                size="small"
                                sx={{ color: "#ffffff", ml: 0.5, p: 0 }}
                              >
                                <InfoOutlinedIcon
                                  fontSize="small"
                                  sx={{ padding: "0px" }}
                                />
                              </IconButton>
                            </Tooltip>
                            <span
                              style={{
                                fontWeight: "bold",
                                fontSize: "12px",
                                paddingLeft: "8px",
                              }}
                            >
                              {totalScore}
                            </span>
                          </Typography>
                          {totalScoreError && (
                            <Typography
                              className="f-12"
                              sx={{
                                fontWeight: "medium",
                                textAlign: "left",
                                color: "#d32f2f",
                                paddingTop: "0px",
                              }}
                            >
                              {totalScoreError}
                            </Typography>
                          )}
                        </Grid>
                        <Grid item xs={12} md={6}>
                          <Typography
                            className="f-11"
                            style={{ color: "#CCCCCC" }}
                          >
                            Total Reward Amount:
                            <span
                              style={{
                                fontWeight: "bold",
                                fontSize: "12px",
                                paddingLeft: "4px",
                              }}
                            >
                              ₹{formData.points || 0}
                            </span>
                          </Typography>
                        </Grid>
                        <Grid item xs={12} md={12}>
                          {" "}
                          <Typography
                            className="f-13"
                            color="#daaa00"
                            fontWeight={600}
                          >
                            Individual/Team Budget
                          </Typography>
                        </Grid>

                        <Grid item xs={12} md={6}>
                          <CustomInput
                            label="Actual Budget"
                            type="text"
                            name="Total"
                            placeholder=""
                            value={`₹ ${
                              budgetData?.allocatedIndividualBudget || 0
                            }`}
                            onChange={() => {}}
                            readOnly={isPreview}
                          />
                        </Grid>
                        <Grid item xs={12} md={6}>
                          <CustomInput
                            label="Utilized Budget"
                            type="text"
                            name="Used"
                            placeholder=""
                            value={`₹ ${budgetData?.usedIndividualBudget || 0}`}
                            onChange={() => {}}
                            readOnly={isPreview}
                          />
                        </Grid>
                        <Grid item xs={12} md={6}>
                          <CustomInput
                            label="Available Budget"
                            type="text"
                            name="Balance"
                            placeholder=""
                            value={`₹ ${
                              budgetData?.availableIndividualBudget || 0
                            }`}
                            onChange={() => {}}
                            readOnly={isPreview}
                          />
                        </Grid>
                      </>
                    )}

                    {selectedRewardType === 3 ? (
                      <>
                        {formData.crossFunctionalType === 2 && (
                          <Grid item xs={12} md={6}>
                            <CustomSelect
                              name="awardType"
                              label="Award Type"
                              placeHolder="Select Type"
                              value={formData.awardType || ""}
                              onChange={handleTypeDropDownChange}
                              error={formErrors.awardType}
                              required
                              options={awardTypeData}
                              readOnly={isPreview}
                            />
                          </Grid>
                        )}

                        <Grid item xs={12} md={6}>
                          <CustomInput
                            label="Total Cross Functional Excellence Score"
                            type="text"
                            name="score"
                            placeholder="Enter Score"
                            value={formData.score}
                            onChange={handleInputChange}
                            error={formErrors.score}
                            required
                            readOnly={isPreview}
                            infoTable={
                              formData.crossFunctionalType === 1 ? (
                                <TrailBlazerScoreTable />
                              ) : formData.crossFunctionalType === 2 ? (
                                <REExcellenceScoreTable />
                              ) : null
                            }
                          />
                        </Grid>
                        <Grid item xs={12} md={6}>
                          <Typography></Typography>
                          <CustomInput
                            label="Total Reward Amount"
                            type="text"
                            name="rewardAmount"
                            placeholder="Total Reward Amount"
                            value={`₹ ${formData.points || 0}`}
                            onChange={() => {}}
                            readOnly={isPreview}
                          />
                        </Grid>
                        <Grid item xs={12} md={12}>
                          {" "}
                          <Typography
                            className="f-13"
                            color="#daaa00"
                            fontWeight={600}
                          >
                            Cross Functional Budget
                          </Typography>
                        </Grid>

                        <Grid item xs={12} md={6}>
                          <CustomInput
                            label="Actual Budget"
                            type="text"
                            name="Total"
                            placeholder=""
                            value={`₹ ${
                              budgetData?.allocatedCrossFunctionalBudget || 0
                            }`}
                            onChange={() => {}}
                            readOnly={isPreview}
                          />
                        </Grid>
                        <Grid item xs={12} md={6}>
                          <CustomInput
                            label="Utilized Budget"
                            type="text"
                            name="Used"
                            placeholder=""
                            value={`₹ ${
                              budgetData?.usedCrossFunctionalBudget || 0
                            }`}
                            onChange={() => {}}
                            readOnly={isPreview}
                          />
                        </Grid>
                        <Grid item xs={12} md={6}>
                          <CustomInput
                            label="Available Budget"
                            type="text"
                            name="Balance"
                            placeholder=""
                            value={`₹ ${
                              budgetData?.availableCrossFunctionalBudget || 0
                            }`}
                            onChange={() => {}}
                            readOnly={isPreview}
                          />
                        </Grid>
                      </>
                    ) : (
                      selectedRewardType !== 2 && (
                        <>
                          <Grid item xs={12} md={6}>
                            <CustomInput
                              label="Score"
                              type="text"
                              name="score"
                              placeholder="Enter Score"
                              value={formData.score}
                              onChange={handleInputChange}
                              error={formErrors.score}
                              required
                              readOnly={isPreview}
                              infoTable={<TrailBlazerScoreTable />}
                            />
                          </Grid>
                          <Grid item xs={12} md={6}>
                            <Typography></Typography>
                            <CustomInput
                              label="Total Reward Amount"
                              type="text"
                              name="rewardAmount"
                              placeholder="Total Reward Amount"
                              value={`₹ ${formData.points || 0}`}
                              onChange={() => {}}
                              readOnly={isPreview}
                            />
                          </Grid>
                          <Grid item xs={12} md={12}>
                            {" "}
                            <Typography
                              className="f-13"
                              color="#daaa00"
                              fontWeight={600}
                            >
                              Individual/Team Budget
                            </Typography>
                          </Grid>

                          <Grid item xs={12} md={6}>
                            <CustomInput
                              label="Actual Budget"
                              type="text"
                              name="Total"
                              placeholder=""
                              value={`₹ ${
                                budgetData?.allocatedIndividualBudget || 0
                              }`}
                              onChange={() => {}}
                              readOnly={isPreview}
                            />
                          </Grid>
                          <Grid item xs={12} md={6}>
                            <CustomInput
                              label="Utilized Budget"
                              type="text"
                              name="Used"
                              placeholder=""
                              value={`₹ ${
                                budgetData?.usedIndividualBudget || 0
                              }`}
                              onChange={() => {}}
                              readOnly={isPreview}
                            />
                          </Grid>
                          <Grid item xs={12} md={6}>
                            <CustomInput
                              label="Available Budget"
                              type="text"
                              name="Balance"
                              placeholder=""
                              value={`₹ ${
                                budgetData?.availableIndividualBudget || 0
                              }`}
                              onChange={() => {}}
                              readOnly={isPreview}
                            />
                          </Grid>
                        </>
                      )
                    )}
                  </>
                )}
              </>
            )}
          </Grid>
        </Box>
      </CustomModal>
      {showConfirmModal && (
        <CustomModal
          open={showConfirmModal}
          handleClose={() => setShowConfirmModal(false)}
          onSave={() => {
            setShowConfirmModal(false);
            setIsPreview(true);
          }}
          title="Confirmation"
          saveButtonName="Yes"
          button2="No"
          onClickButton2={() => setShowConfirmModal(false)}
          width={400}
        >
          <Typography>
            You have already nominated this user once, do you still want to
            proceed?
          </Typography>
        </CustomModal>
      )}
    </>
  );
};

export default RewardsAndRecognitionModal;
